export { default } from "./ClickImage";
